import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Tag,
  Drawer,
  Form,
  Input,
  Row,
  Col,
  Card,
  Typography,
  Badge, Tooltip
} from "antd";
import { EyeOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { ENDPOINT } from "../../Services/ENDPOINT";
import { useNavigate } from "react-router-dom";
import { DatePicker, Select, Space } from "antd";
const { Title } = Typography;
const { RangePicker } = DatePicker;

function ListProject() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewDrawerVisible, setViewDrawerVisible] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const navigate = useNavigate();



  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);




  const fetchProjects = async () => {
    setLoading(true);
    try {
      const response = await axios.get(ENDPOINT.Project);
      const projects = response.data.data;
      const formattedData = projects.map((item, index) => ({
        key: item.id?.toString() || index.toString(),
        id: item.id,
        siNo: index + 1,
        quoteNo: item.qu_no || "-",
        projectNo: item.pro_no || "-",
        projectName: item.pro_name || "-",
        department: item.department_name || "-",
        teamSize: JSON.parse(item.pro_engineer || "[]").length || 0,
        startDate: item.pro_start_date
          ? new Date(item.pro_start_date).toLocaleDateString()
          : "-",
        endDate: item.pro_target_end_date
          ? new Date(item.pro_target_end_date).toLocaleDateString()
          : "-",
        startDateRaw: item.pro_start_date ? new Date(item.pro_start_date) : null,
        endDateRaw: item.pro_target_end_date ? new Date(item.pro_target_end_date) : null,

        status: item.pro_status || "-",
        addedOn: item.added_on
          ? new Date(item.added_on).toLocaleDateString()
          : "-",
      }));

      const uniqueDepartments = [
        ...new Set(formattedData.map((it) => it.department).filter(Boolean))
      ].map((dept) => ({ label: dept, value: dept }));

      setDepartmentOptions(uniqueDepartments);

      const sortedData = formattedData.sort((a, b) => {
        if (a.status?.toLowerCase() === "live") return -1;
        if (b.status?.toLowerCase() === "live") return 1;
        return 0;
      });

      setData(sortedData);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };


  const filteredData = data.filter((item) => {

    const raw = [
      item.projectName || "",
      item.projectNo || "",
      item.department || "",
    ].join(" ").toLowerCase();

    const matchesSearch = !searchText || raw.includes(searchText.toLowerCase());

    const matchesDepartment =
      !selectedDepartments || selectedDepartments.length === 0
        ? true
        : selectedDepartments.includes(item.department);

    const matchesDate = (() => {
      if (!dateRange || dateRange.length !== 2) return true;

      const start = new Date(dateRange[0]);
      const end = new Date(dateRange[1]);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      const projStart = item.startDateRaw;
      const projEnd = item.endDateRaw;

      if (!projStart && !projEnd) return true;
      return (
        (projStart && projStart >= start && projStart <= end) ||
        (projEnd && projEnd >= start && projEnd <= end)
      );
    })();



    return matchesSearch && matchesDepartment && matchesDate;
  });



  useEffect(() => {
    fetchProjects();
  }, []);

  const columns = [
    {
      title: "SI No",
      key: "siNo",
      align: "center",
      render: (_, __, index) => index + 1
    },

    { title: "Project No", dataIndex: "projectNo", key: "projectNo", align: "center" },
    { title: "Project Name", dataIndex: "projectName", key: "projectName", align: "center" },
    { title: "Department", dataIndex: "department", key: "department", align: "center" },
    { title: "Team Size", dataIndex: "teamSize", key: "teamSize", align: "center" },
    { title: "Start Date", dataIndex: "startDate", key: "startDate", align: "center" },
    { title: "Target End Date", dataIndex: "endDate", key: "endDate", align: "center" },
    {
      title: "Alert",
      dataIndex: "endDateRaw",
      key: "alert",
      align: "center",
      render: (endDateRaw, record) => {
        if (!endDateRaw) return null;

        const badgeDotStyle = {
          width: 16,
          height: 16,
          borderRadius: "50%",
          display: "inline-block",
          margin: "0 auto",
        };


        if (record.status?.toLowerCase() === "completed") {
          return (
            <Tooltip title="Completed" placement="top">
              <span
                style={{
                  ...badgeDotStyle,
                  backgroundColor: "green",
                  cursor: "default",
                }}
              />
            </Tooltip>
          );
        }

        const end = new Date(endDateRaw);
        if (isNaN(end)) return null;
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const diffTime = end.getTime() - today.getTime();
        const diffDays = diffTime / (1000 * 3600 * 24);

        let color = null;
        let tooltipText = "";

        const start = new Date(record.startDate);
        if (!isNaN(start)) start.setHours(0, 0, 0, 0);

        if (diffDays < 0) {
          color = "red";
          tooltipText = "Overdue";
        } else if (today >= start && today <= end) {
          color = "yellow";
          tooltipText = "Ongoing";
        } else if (diffDays > 0 && diffDays < 7) {
          color = "orange";
          tooltipText = "Ongoing";
        } else {
          return null;
        }

        return (
          <Tooltip title={tooltipText} placement="top">
            <span
              style={{
                ...badgeDotStyle,
                backgroundColor: color,
                cursor: "default",
              }}
            />
          </Tooltip>
        );
      },
    },


    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        let color = "default";
        switch (status?.toLowerCase()) {
          case "live":
          case "active":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "completed":
            color = "blue";
            break;
          case "cancelled":
            color = "red";
            break;
          default:
            color = "gray";
        }
        return (
          <Tag
            color={color}
            style={{
              fontWeight: 600,
              fontSize: "14px",
              padding: "4px 12px",
              borderRadius: "20px",
              textTransform: "capitalize",
            }}
          >
            {status}
          </Tag>
        );
      },
    },
    { title: "Added On", dataIndex: "addedOn", key: "addedOn", align: "center" },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => {
        const isLive = record.status?.toLowerCase() === "live";
        return (
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <Button
              icon={<EyeOutlined />}
              size="large"
              onClick={() => {
                setSelectedProject(record);
                setViewDrawerVisible(true);
              }}
              style={{ color: "#1890ff", borderColor: "#1890ff" }}
            >
              View
            </Button>

            {isLive ? (
              <Button
                type="default"
                danger
                icon={<PlusOutlined />}
                size="large"
                onClick={() =>
                  navigate("/manage-task/create-task", {
                    state: {
                      projectId: record.id,
                      projectNo: record.projectNo,
                      projectName: record.projectName,
                      department: record.department,
                      startDate: record.startDate,
                      endDate: record.endDate,
                      status: record.status,
                      addedOn: record.addedOn,
                    },
                  })
                }
              >
                Add Task
              </Button>
            ) : (

              <span style={{ width: 104 }} />
            )}
          </div>
        );
      },
    },
  ];

  return (
    <Card title={<Title level={4}>Manage Project and Task</Title>} style={{ borderRadius: 8 }}>

      <Card style={{ marginBottom: 16 }}>
        <Form layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Search" layout="vertical">
                <Input
                  allowClear
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Select Date" layout="vertical">
                <RangePicker
                  allowClear
                  size="large"
                  onChange={(dates) => setDateRange(dates || [])}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Select Departments" layout="vertical">
                <Select
                  allowClear
                  mode="multiple"
                  placeholder="Select departments"
                  options={departmentOptions}
                  value={selectedDepartments}
                  onChange={setSelectedDepartments}
                  size="large"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <Table
        columns={columns}
        dataSource={filteredData}

        loading={loading}
        pagination={{ pageSize: 8 }}
      />

      <Drawer
        title={<Title level={4} style={{ margin: 0 }}>Project Details</Title>}
        width={600}
        onClose={() => setViewDrawerVisible(false)}
        visible={viewDrawerVisible}
        placement="right"
        bodyStyle={{ padding: "24px" }}
      >
        {selectedProject && (
          <Form layout="vertical" colon={false}>
            <Row gutter={[24, 24]}>
              <Col span={12}>
                <Form.Item label="Project No">
                  <Input value={selectedProject.projectNo} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Project Name">
                  <Input value={selectedProject.projectName} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Department">
                  <Input value={selectedProject.department} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Team Size">
                  <Input value={selectedProject.teamSize} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Start Date">
                  <Input value={selectedProject.startDate} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Target End Date">
                  <Input value={selectedProject.endDate} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Status">
                  <Tag
                    color={
                      selectedProject.status.toLowerCase() === "live" ||
                        selectedProject.status.toLowerCase() === "active"
                        ? "green"
                        : selectedProject.status.toLowerCase() === "pending"
                          ? "orange"
                          : selectedProject.status.toLowerCase() === "completed"
                            ? "blue"
                            : "red"
                    }
                    style={{
                      fontWeight: 600,
                      fontSize: 15,
                      padding: "5px 14px",
                      borderRadius: "20px",
                      textTransform: "capitalize",
                    }}
                  >
                    {selectedProject.status}
                  </Tag>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Added On">
                  <Input value={selectedProject.addedOn} readOnly size="large" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
      </Drawer>
    </Card>
  );
}

export default ListProject;
